export const useTypeBlock = (setActiveSelect) => {
    const $stepBody = $('.estimate-step-body');
    const step = $($stepBody).closest(EM.stepClass);

    const changeType = (e, type) => {
        e.stopPropagation();
        setActiveSelect('');
        positionMassEditManager.changeTypePositionsMassEditAction(step, type);
    };
    return { changeType };
};
